/*
 * @Copyright 2026. Institute for Future Intelligence, Inc.
 */

// Singleton handle on the AbortController for the in-flight AI generation, so
// the Stop button on the reasoning panels can reach the request from anywhere
// without prop-drilling. The hook/modal that initiates the call registers a
// fresh controller; cancelCurrentGeneration() aborts whichever is active.

let currentController: AbortController | null = null;

export const setCurrentAbortController = (c: AbortController | null) => {
  currentController = c;
};

// Clear the registered controller ONLY when it's still `c`. Used in a
// `finally` block when a deeper sub-task (e.g. the streaming-call's own
// try/finally) may have replaced our registration with its own controller —
// in that case we must not clobber it on the way out, or the Stop button
// silently becomes a no-op for the rest of the pipeline.
export const clearCurrentAbortControllerIfSelf = (c: AbortController) => {
  if (currentController === c) currentController = null;
};

export const cancelCurrentGeneration = () => {
  currentController?.abort();
};

export const isGenerationCancellable = () => currentController !== null;
